import React,{useState,useRef,useEffect} from 'react'
import { Button, TextField,Fab,FormControl,Select,InputLabel,MenuItem,Stack, Divider, CircularProgress} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch,useSelector } from 'react-redux';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { api } from '../../../../redux/api';
import { newTemplateActions } from '../../../../redux/slices/newTemplateSlice';

function NtwDTDTemplate() {
    const { t } = useTranslation();
    // const label = t('FRG_ENTER_FULL_PATH_TO_').concat(t('DTD'))
    const label = 'Choose DTD File'
    const [dtdFileVal,setDtdFileVal] = useState('');
    const [rootElement,setRootElement] = useState('');
    const [rootElementOptions,setRootElementOptions] = useState([])
    const [isDtdValid,setIsDtdValid] = useState(false);
    const [loading, setLoading] = useState(false)
    const error = useRef();
    const { account } = useSelector((state) => state.queryParams);
    const {DTDTemplateData:data} = useSelector((state) => state.newTemplate)
    const dispatch = useDispatch();
    const fileBrowser = useRef();
    const handleChange = (key, e) => {
        if(key === 'ROOT_ELEMENT'){
         dispatch(newTemplateActions.setDTDTemplateData({...data,rootElement:e.target.value}))
        }
        
      }
    const handleUploadClick = async (e) => {
      const file = e.target.files[0];
      if (!file) {
        return;
      }
      setDtdFileVal(file.name);
      const fileNameWithoutExtension = file.name.split('.').slice(0, -1).join('.');
      let fileInfo = '';
    
      try {
        const reader = new FileReader();
        reader.onload = (e) => {
          fileInfo = e.target.result;
        };
        reader.readAsText(file);
        setLoading(true); 
    
        let formData = new FormData();
        formData.append('file', file);
    
        const response = await dispatch(api.endpoints.validateDTDFile.initiate({
          account: account,
          data: formData,
        }));
    
        if (response.error) {
          throw new Error(response.error.message || t("BOX_MSG_GENERAL_ERROR"));
        }
    
        if (response?.data?.data?.isValidDTDFile) {
          setLoading(false);
          const roots = response?.data?.data?.roots?.myArrayList || [];
          
          if (roots.length === 0) {
            throw new Error(t('BOX_ERR_LOCATING_ROOT__RETYPE_ROOT_ELEM').split(".")[0]);
          }
    
          setIsDtdValid(true);
          setRootElementOptions(roots);
          setRootElement(roots[0]);
          dispatch(newTemplateActions.setDTDTemplateData({ fileInfo, rootElement: roots[0] }));
          dispatch(newTemplateActions.setTemplateName(fileNameWithoutExtension));
    
        } else {
          setLoading(false);
          const errorMessage = response.data.data.message || "File is not valid.";
          error.current.textContent = errorMessage;
          dispatch(newTemplateActions.setDTDTemplateData(''));
          dispatch(newTemplateActions.setTemplateName(''));
        }
      } catch (err) {
        setLoading(false);
        error.current.textContent = err.message || "An unknown error occurred.";
      }
    };
    
    const rootElementDropdownOption = rootElementOptions?.map((option,key)=>(
      <MenuItem key={key} value={option}>{option}</MenuItem>
    ));
    useEffect(()=>{
      dispatch(newTemplateActions.setIsFormData(true))
    },[])
  return (
    <>
      <Stack spacing={"8px"}>
        <div className="flex">
        <TextField
            className="width-100"
            label={label}
            variant="outlined"
            size="small"
            value={dtdFileVal}
            onChange={(e) => {
              // setDtdFileVal(e.target.value);
              error.current.textContent = "";
              // handleChange("FILE", e);
            }}
          />
          <input
            style={{ display: "none" }}
            type="file"
            ref={fileBrowser}
            onChange={(e) => {
              // setDtdFileVal(e.target.value);
              error.current.textContent = "";
              setRootElement('');
              setIsDtdValid(false);
              handleChange("FILE_PATH", e);
              handleUploadClick(e);
            }}
          />
            <Button
              variant="outlined"
              size="small"
              disableElevation
              className="margin-left-4"
              disabled={loading}
              sx={{
                width: "40px",
                padding: "4px 8px",
                minWidth: "40px",
              }}
              onClick={() => {
                fileBrowser.current.click();
              }}>
              {loading ? <CircularProgress size='20px' color='primary'  />:<DriveFolderUploadIcon fontSize="small" />}
            </Button>
          
        </div>
        <div>
          <p className="error" ref={error}></p>
        </div>
        <FormControl size="small" variant="outlined">
          <InputLabel id="validationDropdownLabel">
            {t("LBL_ROOT_ELEM_NM")}
          </InputLabel>
          <Select
            className="width-100"
            labelId="validationDropdownLabel"
            id="validationDropdown"
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 300,
                },
              },
            }}
            disabled={!isDtdValid}
            value={rootElement}
            onChange={(e) => {
              setRootElement(e.target.value);
              handleChange("ROOT_ELEMENT", e);
            }}
            label={t("LBL_ROOT_ELEM_NM")}>
            {rootElementDropdownOption}
          </Select>
        </FormControl>
      </Stack>
    </>
  );
}

export default NtwDTDTemplate